// Scroll-based fade-in animation for images
(function() {
  'use strict';

  // Configuration
  const config = {
    rootMargin: '50px 0px', // Start animation 50px before element enters viewport
    threshold: 0.1 // Trigger when 10% of element is visible
  };

  // Track elements that are in view for stagger delay
  let animationQueue = [];
  let isProcessingQueue = false;

  // Process queue with stagger delay
  function processQueue() {
    if (animationQueue.length === 0) {
      isProcessingQueue = false;
      return;
    }

    isProcessingQueue = true;
    const element = animationQueue.shift();

    // Add loaded class to trigger animation
    element.classList.add('loaded');

    // Process next element after delay
    setTimeout(() => {
      processQueue();
    }, 150); // 150ms stagger delay between elements
  }

  // Create intersection observer
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // Add to animation queue
        animationQueue.push(entry.target);

        // Start processing queue if not already running
        if (!isProcessingQueue) {
          processQueue();
        }

        // Stop observing this element
        observer.unobserve(entry.target);
      }
    });
  }, config);

  // Helper function to check if element should be INCLUDED in animation
  // Only animate images in specific sections, exclude everything else
  function shouldInclude(element) {
    // Only include images that are in specific content sections
    const includedSections = [
      '.image-grid',
      '.image-with-text',
      '.multicolumn',
      '.rich-text',
      '.collage',
      '[data-section-type="image-grid"]',
      '[data-section-type="image-with-text"]',
      '[data-section-type="multicolumn"]',
      '[data-section-type="rich-text"]',
      '[data-section-type="collage"]'
    ];

    // Check if element is within any of the included sections
    for (let selector of includedSections) {
      if (element.closest(selector)) {
        return true;
      }
    }

    return false;
  }

  // Function to observe elements
  function observeElements() {
    // Select all images and videos
    const elements = document.querySelectorAll('img, picture, video');

    elements.forEach(element => {
      // Only animate images in specific sections
      if (shouldInclude(element)) {
        observer.observe(element);
      } else {
        // All other images are immediately visible
        element.classList.add('loaded');
      }
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeElements);
  } else {
    observeElements();
  }

  // Re-observe when new content is dynamically added (e.g., lazy loaded sections)
  const mutationObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) { // Element node
          // Check if node is an image or contains images
          if (node.matches && node.matches('img, picture, video')) {
            if (shouldInclude(node)) {
              observer.observe(node);
            } else {
              node.classList.add('loaded');
            }
          } else {
            const images = node.querySelectorAll && node.querySelectorAll('img, picture, video');
            if (images) {
              images.forEach(img => {
                if (shouldInclude(img)) {
                  observer.observe(img);
                } else {
                  img.classList.add('loaded');
                }
              });
            }
          }
        }
      });
    });
  });

  // Observe the body for changes
  mutationObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
})();
